/** Fallback rates (ILS) when the asset owner did not set hourly / daily pricing. */
export const DEFAULT_BOOKING_HOURLY_PRICE_ILS = 50;
export const DEFAULT_BOOKING_DAILY_PRICE_ILS = 400;

export const BOOKING_HOURLY_PRICING_TYPE_ID = 1;
export const BOOKING_DAILY_PRICING_TYPE_ID = 2;
export const BOOKING_MONTHLY_PRICING_TYPE_ID = 4;
